import axios from '@/api/config';

const goodsAgentPrice = {
    // pageList(data) {
    //     return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/pageList` + data, {});
    // },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/pageList`, data);
    },
    addGoodsAgentPrice(data) {
        return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/addGoodsAgentPrice`, data);
    },
    updateGoodsAgentPriceByBatch(data) {
        return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/updateGoodsAgentPriceByBatch`, data);
    },
    deleteGoodsAgentPrice(data) {
        return axios.delete(`${process.env.BASE_URL}/goodsAgentPrice/deleteGoodsAgentPrice`, { data: data });
    },
    getGoodsAgentPriceList(data) {
        return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/getGoodsAgentPriceList`, { params: data });
    },
}

export default goodsAgentPrice;



// WEBPACK FOOTER //
// ./src/api/goodsAgentPrice.js